module.exports = __webpack_public_path__ + "img/opening_specials.54dffdb2.png";